// The files in the platform agent's message box (D6, docs/platform-agent/contracts.md §8). The label, placeholder
// and hint stay in PlatformAgentConversation's `composer`.
export default {
  drop: 'Slip filer her: PDF, fotos, Excel, CSV eller Word',
  waiting: 'Afsendelsen venter, til filerne er uploadet.',
  // A PDF's pages on its tile (B37): "PDF · 1.2 MB · 4 pages".
  pages_one: '{{count}} side',
  pages_other: '{{count}} sider',
  problems: {
    type: 'Denne filtype kan ikke sendes. Send en PDF, et foto (JPG, PNG eller HEIC) eller en Excel-, CSV- eller Word-fil.',
    size: 'Over 20 MB. En fil må højst være på 20 MB.',
    empty: 'Denne fil er tom.',
    count: 'Op til 10 filer pr. besked.',
    upload: 'Uploadet blev afbrudt. Prøv igen.',
  },
};
